import { render, staticRenderFns } from "./getCorporate.vue?vue&type=template&id=ff21cd92"
import script from "./getCorporate.vue?vue&type=script&lang=js"
export * from "./getCorporate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports